import {
  WorkOrderFilters,
  WorkOrderSortDirection,
  WorkOrderSortField,
  WorkOrderStatus,
} from "@myapp/contract";
import {
  toOptionalNumber,
  toOptionalString,
} from "../../../../shared/lib/optionalParsers";

export interface WorkOrderFiltersForm {
  workOrderId: string;
  mieter: string;
  handwerker: string;
  datum: string;
  wohnung: string;
  hauseingang: string;
  ve: string;
  sortField: WorkOrderSortField;
  sortDirection: WorkOrderSortDirection;
  status: WorkOrderStatus | null;
  gewerkId: number | null;
}

export const INITIAL_WORK_ORDER_FILTERS: WorkOrderFiltersForm = {
  workOrderId: "",
  mieter: "",
  handwerker: "",
  datum: "",
  wohnung: "",
  hauseingang: "",
  ve: "",
  sortField: "workOrderId",
  sortDirection: "DESC",
  status: null,
  gewerkId: null,
};

export const mapFiltersFormToApi = (
  filters: WorkOrderFiltersForm,
  limit: number,
): WorkOrderFilters => ({
  limit,
  workOrderId: toOptionalString(filters.workOrderId),
  mieter: toOptionalString(filters.mieter),
  handwerker: toOptionalString(filters.handwerker),
  datum: toOptionalString(filters.datum),
  wohnung: toOptionalNumber(filters.wohnung),
  hauseingang: toOptionalString(filters.hauseingang),
  ve: toOptionalNumber(filters.ve),
  veAdresse: toOptionalString(filters.ve),
  sortField: filters.sortField,
  sortDirection: filters.sortDirection,
  status: filters.status ?? undefined,
  gewerkId: filters.gewerkId ?? undefined,
});
